import { render, staticRenderFns } from "./24welHeader.vue?vue&type=template&id=fea44e42&scoped=true&"
import script from "./24welHeader.vue?vue&type=script&lang=js&"
export * from "./24welHeader.vue?vue&type=script&lang=js&"
import style0 from "./24welHeader.vue?vue&type=style&index=0&id=fea44e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea44e42",
  null
  
)

export default component.exports